import { render } from "./deleteButtonMulti.vue?vue&type=template&id=072dabef"
import script from "./deleteButtonMulti.vue?vue&type=script&lang=ts"
export * from "./deleteButtonMulti.vue?vue&type=script&lang=ts"
script.render = render

export default script